import { render, staticRenderFns } from "./NumbersList.vue?vue&type=template&id=13a58e7e&scoped=true&"
import script from "./NumbersList.vue?vue&type=script&lang=js&"
export * from "./NumbersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a58e7e",
  null
  
)

export default component.exports